import { IonIcon } from '@ionic/react'
import { openOutline } from 'ionicons/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { logEvent } from '../../analytics/utils/firebaseUtils'
import PageWrapper from '../../wrappers/pageWrapper/PageWrapper'

export const ContactSupport = () => {
	const { t } = useTranslation('pages_contactSupport')

	const onClickEmail = () => {
		logEvent('click-support-email')
	}

	const onClickPhoneNumber = () => {
		logEvent('click-support-phone')
	}

	return (
		<PageWrapper page='contact-support-info' appBarOptions={{ backPath: '/overview' }}>
			<div className='container'>
				<div className='info-container'>
					<div className='info text-text-dark dark:text-white flex flex-col gap-2'>
						<h1 className='text-xl mb-2'>{t('title')}</h1>
						<p>
							{t('email')}
							<a onClickCapture={onClickEmail} href={`mailto:${t('supportEmail')}`}>
								{t('supportEmail')}
							</a>
						</p>
						<p>
							{t('phone')}
							<a onClickCapture={onClickPhoneNumber} href={`tel:${t('supportNumber')}`}>
								{t('supportNumber')}
							</a>
						</p>
						<p>{t('openTimes')}</p>

						<p>
							<a
								className='flex flex-row gap-2 items-center text-highlight font-semibold tracking-wide'
								href={t('supportUrl')}
							>
								{t('faq')} <IonIcon icon={openOutline} />
							</a>
						</p>
					</div>
				</div>
			</div>
		</PageWrapper>
	)
}
